<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="tx"><span epub:type="pagebreak" id="pagevii" title="vii"></span></p>
<p class="_toc" id="_idParaDest-3">Contents<a id="_idTextAnchor000"></a></p>
<p class="toc-ch-"><a href="#/HKWH#_idTextAnchor001"> <span>Introduction</span></a> </p>
<p class="toc-part"><a href="#/HKWH1#_idTextAnchor002">THE KITCHEN PHARMACY</a></p>
<p class="toc-ch-"><a href="#/HKWH2#_idTextAnchor003">Making Your Own Herbal Remedies</a> </p>
<p class="toc-ch-"><span epub:type="pagebreak" id="pageviii" title="viii"><a href="#/HKWH3#_idTextAnchor004">Internal Remedies</a> </span></p>
<p class="toc-ch-"><a href="#/HKWH4#_idTextAnchor006"> <span>External Remedies</span></a> </p>
<p class="toc-ch-"><a href="#/HKWH5#_idTextAnchor009"> <span>Cosmetic Uses of</span> <span> Herbs</span></a> </p>
<p class="toc-ch-"><span epub:type="pagebreak" id="pageix" title="ix"><a href="#/HKWH6#_idTextAnchor010"> <span>Your Magical Works</span> <span>h</span> <span>op</span></a> </span></p>
<p class="toc-part"><a href="#/HKWH7#_idTextAnchor012">A-Z HERBAL</a></p>
<p class="toc-ch-"><a href="#/HKWH8#_idTextAnchor013"> <span>Basil</span></a> </p>
<p class="toc-ch-"><a href="#/HKWH9#_idTextAnchor014"> <span>Black Pepper</span></a> </p>
<p class="toc-ch-"><a href="#/HKWH10#_idTextAnchor015"> <span>Caraway</span></a> </p>
<p class="toc-ch-"><a href="#/HKWH11#_idTextAnchor016"> <span>Cardamom</span></a> </p>
<p class="toc-ch-"><a href="#/HKWH12#_idTextAnchor017"> <span>Chilli/Cayenne</span></a> </p>
<p class="toc-ch-"><a href="#/HKWH13#_idTextAnchor018"> <span>Cinnamon</span></a></p>
<p class="toc-ch-"><span epub:type="pagebreak" id="pagex" title="x"><a href="#/HKWH14#_idTextAnchor021"> <span>Clove</span></a></span></p>
<p class="toc-ch-"><a href="#/HKWH15#_idTextAnchor022"> <span>Coriander</span></a></p>
<p class="toc-ch-"><a href="#/HKWH16#_idTextAnchor023"> <span>Cumin</span></a></p>
<p class="toc-ch-"><a href="#/HKWH17#_idTextAnchor024"> <span>Dill</span></a></p>
<p class="toc-ch-"><a href="#/HKWH18#_idTextAnchor025"> <span>Fennel</span></a></p>
<p class="toc-ch-"><a href="#/HKWH19#_idTextAnchor026"> <span>Fenugreek</span></a></p>
<p class="toc-ch-"><a href="#/HKWH20#_idTextAnchor027"> <span>Garlic</span></a></p>
<p class="toc-ch-"><a href="#/HKWH21#_idTextAnchor028"> <span>Ginger</span></a></p>
<p class="toc-ch-"><a href="#/HKWH22#_idTextAnchor029"> <span>Lemon</span></a></p>
<p class="toc-ch-"><span epub:type="pagebreak" id="pagexi" title="xi"><a href="#/HKWH23#_idTextAnchor030"> <span>Mints</span></a></span></p>
<p class="toc-ch-"><a href="#/HKWH24#_idTextAnchor031"> <span>Oats</span></a></p>
<p class="toc-ch-"><a href="#/HKWH25#_idTextAnchor032"> <span>Oregano</span></a></p>
<p class="toc-ch-"><a href="#/HKWH26#_idTextAnchor033"> <span>Parsley</span></a></p>
<p class="toc-ch-"><a href="#/HKWH27#_idTextAnchor034"> <span>Rosemary</span></a></p>
<p class="toc-ch-"><a href="#/HKWH28#_idTextAnchor035"> <span>Sage</span></a></p>
<p class="toc-ch-"><a href="#/HKWH29#_idTextAnchor036"> <span>Thyme</span></a></p>
<p class="toc-ch-"><a href="#/HKWH30#_idTextAnchor037"> <span>Turmeric</span></a></p>
<p class="toc-part"><span epub:type="pagebreak" id="pagexii" title="xii"><a href="#/HKWH31#_idTextAnchor038"> <span>OTHER KITCHEN HERBS IN BRIEF</span></a></span></p>
<p class="toc-cn"> <span>appendix 1: </span><a href="#/HKWH32#_idTextAnchor040"> <span>Kitchen Herb Magical Correspondences</span></a> </p>
<p class="toc-cn"> <span>appendix 2: </span><a href="#/HKWH33#_idTextAnchor042"> <span>Colour Correspondences</span></a> </p>
<p class="toc-cn"> <span>appendix 3: </span><a href="#/HKWH34#_idTextAnchor043"> <span>Herbs for Common Ailments</span></a> </p>
<p class="toc-cn"> <span>appendix 4: </span><a href="#/HKWH35#_idTextAnchor044"> <span>Glossary of Herbal Terminology</span></a> </p>
<p class="toc-cn"> <span>appendix 5: </span><a href="#/HKWH36#_idTextAnchor045"> <span>Cosmetic Uses of Herbs in This Book</span></a> </p>
<p class="toc-cn"> <span>appendix 6: </span><a href="#/HKWH37#_idTextAnchor046"> <span>Weights and Measures</span></a> </p>
<p class="toc-cn"><a href="#/HKWH37#_idTextAnchor047"> <span>Select Bibliography</span></a> </p>
<p class="toc-cn"><a href="#/HKWH37#_idTextAnchor048"> <span>Recipe Index</span></a> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?7d0a9945